var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadsMissing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 410,
    viewBox: "0 0 410 410",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m30,623.68l150,-150l-150,-150l-150,150l150,150z",
    id: "bq5lusvnE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 412,
    height: 412,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "shadow12064157",
    x: -230,
    y: 213.68,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "m200,350.000007l150,-150l-150,-150l-150,150l150,150z",
    id: "eHnidaGEE",
    fill: "white",
    filter: "url(#shadow12064157)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bq5lusvnE",
    fill: "#8f2d56",
    id: "svg_4",
    y: -273.679993,
    x: 170
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bq5lusvnE",
    fillOpacity: 0,
    stroke: "#8f2d56",
    strokeWidth: 90,
    strokeOpacity: 0.67,
    id: "svg_6",
    y: -273.679993,
    x: 170
  })))), /*#__PURE__*/React.createElement("text", {
    stroke: "#000",
    transform: "matrix(7.680335521697998,0,0,7.609161853790282,-1084.931969165802,-1151.3818813785908) ",
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 24,
    id: "svg_33",
    y: 185.722207,
    x: 160.302026,
    strokeWidth: 0,
    fill: "#ffffff"
  }, "L"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadsMissing);
export default __webpack_public_path__ + "static/media/LoadsMissing.b8a0945aaddb76c7e8152fc615b9946c.svg";
export { ForwardRef as ReactComponent };